import { useCallback, useState } from "react"
import { useFallBack } from "Components/useFallBack"
import { usePatient } from "Components/usePatientContext"
import { usePagination } from "./usePagination"
import { toast } from "react-toastify"
import api from "lib/api_clinica"

const ITEMS_PER_PAGE = 6

export default function useDias() {

    const [ loading, setLoading ] = useState(false)
    const { modal, isOpen, setOpen } = useFallBack()
    const { patient, setRedirect, setAgenda } = usePatient()

    const { 
        items,
        data,
        count,
        page,
        updatePagination,
        onPageChange
    } = usePagination(ITEMS_PER_PAGE)

    const getDias = useCallback(async () => { 

        try {

            setLoading(true)

            const response = await api.dias.get(patient)
            
            if (!response || response.length === 0) {
                console.log('ENTREI')
                setOpen(true)
                return
            }

            updatePagination(response)

        } catch (error) {
            console.log(error)
            setOpen(true)
            toast.error('Ocorreu um erro ao exibir o dia')   
        } finally {
            setLoading(false)
        }

    }, [ 
        setLoading, 
        patient, 
        setOpen, 
        updatePagination 
    ])

    const selectItem = day => {
        setAgenda(prevState => ({...prevState, diaEscolhido: day}))
        setRedirect('/profissional')
    }

    return {
        loading,
        items,
        data,
        count,
        page,
        onPageChange,
        selectItem,
        getDias,
        setAgenda,
        patient,
        isOpen,
        modal,
        ITEMS_PER_PAGE
    }
}
